import { Component, Input } from '@angular/core';

/**
 * Used to work around i18n limitations
 */
@Component({
    selector: '[render-claim-status]',
    template: `
@switch (status) {
  @case (0) {
    <ng-container i18n="@@claims.status.reported">
                Reported
            </ng-container>
  }
  @case (1) {
    <ng-container i18n="@@claims.status.inprogress">
                In progress
            </ng-container>
  }
  @case (2) {
    <ng-container i18n="@@claims.status.assigned">
                Approved
            </ng-container>
  }
  @case (3) {
    <ng-container i18n="@@claims.status.rejected">
                Rejected
            </ng-container>
  }
  @case (4) {
    <ng-container i18n="@@claims.status.removed">
                Removed
            </ng-container>
  }
  @default {
    <ng-container i18n="@@claims.status.unknown">
                Unknown
            </ng-container>
  }
}
`,
    standalone: true,
})
export class RenderClaimStatusComponent {
    @Input() status: number;
}
